<button class="mm-lang-switch" type="button" (click)="lang.toggle()"
        [attr.aria-label]="(lang.lang$ | async) === 'ar' ? 'Switch to English' : 'Switch to Arabic'"
        [attr.title]="(lang.lang$ | async) === 'ar' ? 'English' : 'العربية'">
  <i class="fa fa-globe" aria-hidden="true"></i>
  <span class="mm-lang-switch-label">{{ (lang.lang$ | async) === 'ar' ? 'English' : 'العربية' }}</span>
</button>
